export const SUPPLIER_CRM_PATH = '/CRM/suppliers/minimal';
